<div class="view-wrapper">
	<div class="thread-wrapper">


		<div class="loader-wrapper" [ngClass]="{'loader-wrapper-active':svcAsstData.asstThinking}">
			@for (
					i of [0, 1, 2, 3]; track i) {
				<div class="loader-block" [ngStyle]="{animationDelay: (i * 250)+'ms'}"></div>
			}
		</div>

		@if (svcAsstData.asstCoachRes.content.length) {
			<app-asst-summarizer-message [msg]="svcAsstData.asstCoachRes"></app-asst-summarizer-message>
		}


		@for (
				msg of (svcAsstData.coachingLogs | async); track msg.id) {
			<app-asst-summarizer-message [msg]="msg"></app-asst-summarizer-message>
		}


	</div>
	<div class="thread-input">
		<textarea [(ngModel)]="svcAsstData.userCoachReq" placeholder="Your Thoughts"></textarea>
	</div>
	<div class="thread-controls" OnHold (onHold)="svcAsstData.getAsstCoaching()">
		SEND
	</div>

</div>